module.exports = __webpack_public_path__ + "static/media/Kagehina.5d267148.png";